import { render, staticRenderFns } from "./Exchanges.vue?vue&type=template&id=f20b6ea0&"
import script from "./Exchanges.vue?vue&type=script&lang=ts&"
export * from "./Exchanges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports